/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */

module.exports = require('./../../lib/adapters/react-dom').default;



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/dom/react/index.js
// module id = 39
// module chunks = 35783957827783 127651196306611 162898551421021